import { CheckCircle, Users, FileText, Clock } from 'lucide-react';

interface Step {
  id: string;
  title: string;
  subtitle?: string;
  icon: React.ReactNode;
  status: 'completed' | 'current' | 'upcoming';
}

export function ProgressStepper() {
  const steps: Step[] = [
    {
      id: '1',
      title: 'Initial Submission',
      icon: <CheckCircle className="w-5 h-5" />,
      status: 'completed',
    },
    {
      id: '2',
      title: 'Mentor Review Window',
      icon: <Users className="w-5 h-5" />,
      status: 'completed',
    },
    {
      id: '3',
      title: 'Final Idea Submission',
      icon: <FileText className="w-5 h-5" />,
      status: 'current',
    },
    {
      id: '4',
      title: 'Jury Evaluation',
      icon: <Clock className="w-5 h-5" />,
      status: 'upcoming',
    },
  ];

  return (
    <div className="bg-white rounded-xl p-6">
      <h2 className="text-lg mb-6 text-gray-900">Submission Progress</h2>
      
      <div className="relative">
        {/* Steps */}
        <div className="flex justify-between items-start">
          {steps.map((step, index) => (
            <div key={step.id} className="flex flex-col items-center flex-1">
              {/* Icon Circle */}
              <div
                className={`
                  relative z-10 w-12 h-12 rounded-full flex items-center justify-center
                  ${step.status === 'completed' 
                    ? 'bg-blue-600 text-white' 
                    : step.status === 'current'
                    ? 'bg-white border-4 border-blue-600 text-blue-600'
                    : 'bg-white border-2 border-gray-300 text-gray-400'
                  }
                `}
              >
                {step.icon}
              </div>
              
              {/* Label */}
              <div className="mt-3 text-center max-w-[100px]">
                <div className={`
                  text-xs
                  ${step.status === 'completed' || step.status === 'current' ? 'text-gray-900' : 'text-gray-400'}
                `}>
                  {step.title}
                </div>
              </div>
              
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div 
                  className={`absolute top-6 h-0.5 ${
                    steps[index + 1].status === 'completed' ? 'bg-blue-600' : 'bg-gray-300'
                  }`}
                  style={{
                    left: `${(100 / steps.length) * (index + 0.5)}%`,
                    width: `${100 / steps.length}%`,
                  }}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
